import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import styled, { css } from 'styled-components';
import { Card, Typography } from '@/components/atoms';
import { ICardSkeleton } from './ICardSkeletonCmp';

const SkeletonCard = styled(Card)<ICardSkeleton>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  ${props =>
    props.template === 'collection' &&
    css`
      max-width: 276px;
      margin: 0 auto;
    `}
`;

const SkeletonRect = styled(Skeleton)<ICardSkeleton>`
  ${props =>
    props.template === 'artisans_with_products' &&
    css`
      padding-top: 133.333%;
    `};
  ${props =>
    props.template === 'collection' &&
    css`
      margin: 0 auto;
      padding-top: 80%;
      width: 100%;
      min-height: 200px;
      ${props => props.theme.breakpoints.up('mobileL')} {
        min-height: 270px;
      }
      ${props => props.theme.breakpoints.up('sm')} {
        min-height: 320px;
      }
    `};
`;

const SkeletonGroupText = styled.div<ICardSkeleton>`
  display: flex;
  flex-direction: column;
  ${props =>
    props.template === 'artisans_with_products' &&
    css`
      align-items: stretch;
    `}
  ${props =>
    props.template === 'collection' &&
    css`
      width: 100%;
      margin: 0 auto 4px;
    `};
`;

const SkeletonUpperInfos = styled.div<ICardSkeleton>`
  display: flex;
  width: 100%;
  margin-bottom: 8px;
`;

const SkeletonImageWrapper = styled.div`
  width: 100%;
`;

const CustomTypography = styled(Typography)`
  line-height: 0.7rem;

  ${props => props.theme.breakpoints.up('mobileL')} {
    line-height: 1rem;
  }
`;

const CardSkeleton: React.FC<ICardSkeleton> = ({ template = 'collection' }) => {
  let skeleton = null;
  switch (template) {
    case 'artisans_with_products':
      skeleton = (
        <SkeletonCard template={template}>
          <SkeletonUpperInfos>
            <SkeletonImageWrapper>
              <Skeleton
                variant="rect"
                className="frame"
                style={{ width: '100%', height: '100%', paddingTop: '75%' }}
              />
            </SkeletonImageWrapper>
          </SkeletonUpperInfos>
          <div>
            <Skeleton variant="rect" height={16} style={{ width: '40%' }} />
          </div>
        </SkeletonCard>
      );
      break;
    case 'collection':
      skeleton = (
        <SkeletonCard template={template}>
          <SkeletonRect variant="rect" template={template} />

          <SkeletonGroupText template={template}>
            <CustomTypography datatype="body_1">
              <Skeleton style={{ width: '40%', margin: 0 }} />
              <Skeleton style={{ width: '80%' }} />
              <Skeleton style={{ width: '80%' }} />
              <Skeleton style={{ width: '80%' }} />
            </CustomTypography>
          </SkeletonGroupText>
        </SkeletonCard>
      );
  }

  return skeleton;
};

export default CardSkeleton;
